// extracted by mini-css-extract-plugin
export default {"heading":"EditPaymentMethodModal_heading__T99qv","explanation":"EditPaymentMethodModal_explanation__BDVP2"};